module.exports = __webpack_public_path__ + "static/bb-sign 2-92f28865abcd49e20bb833b93c240f6c.jpg";